import { render, staticRenderFns } from "./EndosadosPage.vue?vue&type=template&id=055d6792"
import script from "./EndosadosPage.vue?vue&type=script&lang=js"
export * from "./EndosadosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports